"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.4.2'] && _();
}
catch (e) { }
